<template>
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.4062 3.22917C18.4062 3.14352 18.3722 3.06139 18.3117 3.00083C18.2511 2.94027 18.169 2.90625 18.0833 2.90625H9.04166C8.09959 2.90625 7.1961 3.28049 6.52996 3.94663C5.86381 4.61278 5.48958 5.51626 5.48958 6.45833V24.5417C5.48958 25.4837 5.86381 26.3872 6.52996 27.0534C7.1961 27.7195 8.09959 28.0938 9.04166 28.0938H21.9583C22.9004 28.0938 23.8039 27.7195 24.47 27.0534C25.1362 26.3872 25.5104 25.4837 25.5104 24.5417V11.8149C25.5104 11.7292 25.4764 11.6471 25.4158 11.5865C25.3553 11.526 25.2731 11.492 25.1875 11.492H19.375C19.1181 11.492 18.8717 11.3899 18.69 11.2082C18.5083 11.0265 18.4062 10.7801 18.4062 10.5232V3.22917ZM19.375 15.8229C19.6319 15.8229 19.8783 15.925 20.06 16.1067C20.2417 16.2883 20.3437 16.5347 20.3437 16.7917C20.3437 17.0486 20.2417 17.295 20.06 17.4767C19.8783 17.6584 19.6319 17.7604 19.375 17.7604H11.625C11.3681 17.7604 11.1217 17.6584 10.94 17.4767C10.7583 17.295 10.6562 17.0486 10.6562 16.7917C10.6562 16.5347 10.7583 16.2883 10.94 16.1067C11.1217 15.925 11.3681 15.8229 11.625 15.8229H19.375ZM19.375 20.9896C19.6319 20.9896 19.8783 21.0916 20.06 21.2733C20.2417 21.455 20.3437 21.7014 20.3437 21.9583C20.3437 22.2153 20.2417 22.4617 20.06 22.6433C19.8783 22.825 19.6319 22.9271 19.375 22.9271H11.625C11.3681 22.9271 11.1217 22.825 10.94 22.6433C10.7583 22.4617 10.6562 22.2153 10.6562 21.9583C10.6562 21.7014 10.7583 21.455 10.94 21.2733C11.1217 21.0916 11.3681 20.9896 11.625 20.9896H19.375Z"
      fill="black"
      :class="containerClass"
    />
    <path
      d="M20.3438 3.64763C20.3438 3.40996 20.593 3.25884 20.7778 3.40738C20.9345 3.53396 21.0735 3.68121 21.195 3.84913L25.0868 9.27026C25.1746 9.39426 25.079 9.55442 24.9266 9.55442H20.6667C20.581 9.55442 20.4989 9.5204 20.4383 9.45984C20.3778 9.39928 20.3438 9.31715 20.3438 9.23151V3.64763Z"
      fill="black"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
